import {useController} from "react-hook-form";
import {useEffect, useRef, useState} from "react";
import {getBase64} from "../../../utils/imagesHandlers";

const useARAvatar = ({control, name}) => {
  const {
    field: {onChange, value}
  } = useController({name, control});

  const initialAvatarRef = useRef(value);

  const [avatarState, setAvatarState] = useState({
    name: null,
    src: value
  });

  useEffect(() => {
    setAvatarState((prevState) => {
      if (prevState.name) {
        return prevState;
      }

      initialAvatarRef.current = value;
      return {
        ...prevState,
        src: value
      };
    });
  }, [value]);

  const onDeleteUploadedImage = (event) => {
    const newEvent = {...event, type: "change", target: {...event.target, value: initialAvatarRef.current}};
    onChange && onChange(newEvent);

    setAvatarState({
      name: null,
      src: initialAvatarRef.current
    });
  };

  const onUploadImageClick = ({target}) => {
    target.nextSibling.click();
  };

  const onUploadImage = async (event) => {
    const file = event.target.files[0];

    if (file !== undefined) {
      const src = await getBase64(file);

      const newEvent = {...event, target: {...event.target, value: file}};
      onChange && onChange(newEvent);

      setAvatarState({
        name: file.name,
        src
      });
    }
  };

  return {
    avatarState,
    onUploadImageClick,
    onUploadImage,
    onDeleteUploadedImage
  };
};

export default useARAvatar;